export default __webpack_public_path__ + "static/media/planet.be614292.svg";